import { render, staticRenderFns } from "./emp.vue?vue&type=template&id=0f1ac971&scoped=true&"
import script from "./emp.vue?vue&type=script&lang=js&"
export * from "./emp.vue?vue&type=script&lang=js&"
import style0 from "./emp.vue?vue&type=style&index=0&id=0f1ac971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1ac971",
  null
  
)

export default component.exports